import { Dispatch } from "redux";
import { getFunds } from "./";
import { IState, IAppParams } from "../models";
import { INFINITE_SCROLL_LIMIT } from "../config";

export function execInfiniteScroll(appParams: IAppParams, showAll: boolean = false, showAllButton: boolean = false) {
	return async (dispatch: Dispatch<IState>, getState: () => IState) => {
		let state = getState();

		//Reset the offset to zero if we're going to show all funds.
		let offset = showAll ? 0 : state.infiniteScroll.offset + INFINITE_SCROLL_LIMIT;
		let options = showAll ? { search: state.filter.search, ...{ limit: 0 } } : state.filter;
		let funds = await getFunds(options, appParams, false, offset);
		funds(dispatch, getState);

    // manually trigger scroll for filter sidebar
    window.scroll(window.pageYOffset, window.pageYOffset + 2);
    };
}



// WEBPACK FOOTER //
// ./src/client/actions/infiniteScroll.ts